import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/seo/site-xl.png")